import React, {useState} from "react";
import {useEventList, useSelectEventList} from "../hooks/useEvent";
import {ErrorAlert, Footer, Header, Loading, Pagination} from "../components";
import {Link} from "react-router-dom";
import resource from "../utils/resource";

const Event = () => {
    const [pageNumber, setPageNumber] = useState(0);
    const pageSize = 6;

    const {
        data: eventListData,
        isLoading: isEventListLoading,
        isError: isEventListError
    } = useEventList(pageNumber, pageSize);

    const eventList = eventListData?.content || [];
    const totalPages = eventListData?.totalPages || 0;

    const {
        data: selectEventListData,
        isLoading: isSelectEventListLoading,
        isError: isSelectEventListError
    } = useSelectEventList(0, 5);

    const selectEventList = selectEventListData?.content || [];

    return (
        <div>
            <Header/>
            <div className="wrapper">
                <div className="container">
                    <div className="tab-content pt-lg-3">
                        <div className="mainInfo infoContnt">
                            <div className="infoArea infoList">
                                <div className="infoList eventList">
                                    <div className="row">
                                        {/*<h4 className="event_title">最新活動</h4>*/}
                                        <div className="row">
                                            {isEventListLoading && <Loading/>}
                                            {isEventListError && <ErrorAlert message={"查詢領域類型異常"}/>}
                                            {!isEventListLoading && eventList?.map((eventData, index) => (
                                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3 px-3" key={eventData.id}>
                                                        <figure className={`card card_event ${eventData.latestEvents === 'Y' ? 'new_event' : ''}`}>
                                                            {eventData.latestEvents === 'Y' ? <h6>最新活動</h6> : <h6>精選活動</h6>}
                                                            <div className="card_img">
                                                                <img
                                                                    src={resource(eventData.imgUrl)}
                                                                    alt={eventData.eventName}
                                                                />
                                                            </div>
                                                            <div className="card-body">
                                                                <h5 className="card-title">{eventData.eventName}</h5>
                                                                <p className="card-text d-flex">
                                                                    <span>{eventData.releaseDate}</span>
                                                                    <Link to={eventData.link}
                                                                          className="btn">活動介紹</Link>
                                                                </p>
                                                            </div>
                                                        </figure>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <Pagination
                                            currentPage={pageNumber}
                                            totalPages={totalPages}
                                            onPageChange={(newPage) => setPageNumber(newPage)}
                                            isLoading={isEventListLoading}
                                            isError={isEventListError}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default Event;
